export default function() {

    var lastScrollTop = 0;

    $(window).scroll(function(event){

        var scrollTop = $(this).scrollTop();
        var offset = $('.action-bar').outerHeight()
        + $('#wpadminbar').outerHeight()
        + $('.kindling-development-environment-bar').outerHeight()
        + $('.site-header').outerHeight();



        if (scrollTop > lastScrollTop){
            // downscroll code
            // console.log('scrolling down');

            if ($(document).scrollTop() > offset * 2 ){

                $('.site-header').removeClass('show')
                    .addClass('hide')
                    .addClass('fix-to-top')
                    .css('margin-top', '0');

                $('body').css('padding-top', offset); //adds up all headers plus the yellow border width plus margin for the page header
            }

       } else {
            // upscroll code
            // console.log('scrolling up');

            var distanceTop = $('.action-bar').outerHeight()
            + $('#wpadminbar').outerHeight()
            + $('.kindling-development-environment-bar').outerHeight();

            if ($(document).scrollTop() > offset * 2 ){
                $('.site-header').addClass('fix-to-top').addClass('animate').removeClass('hide').addClass('show').css('top', distanceTop);
                $('body').css('padding-top', offset ); //adds up all headers plus the yellow border width plus margin for the page header
            }

            if( $(document).scrollTop() < 1 ) {
                offset = $('.action-bar').outerHeight()
                        + $('.kindling-development-environment-bar').outerHeight();

                $('.site-header').removeClass('fix-to-top')
                    .removeClass('hide')
                    .removeClass('show')
                    .removeClass('animate')
                    .css('margin-top', offset)
                    .css('top', 'auto');

                $('body').css('padding-top', '0');
            }
       }
       lastScrollTop = scrollTop;
    });

}
